{
  "oneOf": {
    "J5ListV1FieldType": {
      "in": "In",
      "range": "Range",
      "value": "Value"
    },
    "J5ListV1Filter": {
      "and": "And",
      "field": "Field",
      "or": "Or"
    }
  }
}